import { Injectable } from '@tanbo/vue-di-plugin'
import { TableMemoryPagination } from '@/services/table-memory-pagination'

export interface QueryParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 端口号 */
  port_num: number
  /** 排序,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段（终端名：computer_name，绑定IP：bind_ip，监听的进程名：process_name，登录状态：login_status，分组名：group_name） */
  sort?: string,
  /** 是否使用内存数据 */
  useMemory: boolean
}
export interface BlockQueryParams {
  /** 规则id */
  rule_id: number
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段（终端名：computer_name，绑定IP：bind_ip，监听的进程名：process_name，登录状态：login_status，分组名：group_name） */
  sort?: string,
  /** 是否使用内存数据 */
  useMemory: boolean
  /** 系统类型 1-windows 2-linux 3-win server 4-mac */
  system_types: number[]
}
export interface TerminalItem {
  /** 设备id */
  device_id: string
  /** 终端名 */
  computer_name: string
  /** 分组名 */
  group_name: string
  /** IP地址 */
  system_ip: string
  /** 绑定IP */
  bind_ip: string
  /** 监听的进程名 */
  process_name: string
  /** 登录状态,1->在线，2->离线 */
  login_status: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
}

/**
 * 注入用基类：仅继承 TableMemoryPagination 的跨页选择与 refresh 能力。
 * 查询参数、当前端口/规则、阻断/解除接口由各 DrawerService 以普通类方法自行实现，不在此声明 abstract 约束。
 */
@Injectable()
export abstract class AbstractTerminalViewService extends TableMemoryPagination<QueryParams|BlockQueryParams, TerminalItem> {}
